export default __webpack_public_path__ + "static/media/Pending_Icon.80a6273c.svg";